export default __webpack_public_path__ + "static/media/ilus5.47f12341.jpeg";